import React from 'react';

import { MDText } from 'i18n-react';

import { type HeroAnimationState } from 'Utilities/animation';

import { TrustPilotHero } from '../../../homepage/Components/Hero/SubComponents/HomepageVRM/TrustPilotHero';
import LocalTexts from '../HeroFinance.texts.json';
import { HeroFinanceQuestion } from '../HeroFinanceQuestion/HeroFinanceQuestion';

import styles from './HeroFinance.scss';

const LocalT = new MDText(LocalTexts);

type HeroFinanceProps = {
  loadingHandler: (state: HeroAnimationState) => void;
  onFinanceSubmit: (isOnFinance: boolean) => void;
};

export const HeroFinance = ({
  loadingHandler,
  onFinanceSubmit,
}: HeroFinanceProps) => (
  <div className={styles.heroFinance}>
    <div>
      <h2 className={styles.heading}>{LocalT.translate('title')}</h2>
      <p data-thc-style-override className={styles.subtitle}>
        {LocalT.translate('subtitle')}
      </p>
    </div>
    <HeroFinanceQuestion
      loadingHandler={loadingHandler}
      onFinanceSubmit={onFinanceSubmit}
    />
    <TrustPilotHero />
  </div>
);
